<template>
  <LoggedIn v-if="authenticated" :qualified_profile="qualified_profile" />
  <HelloWorld v-else/>
</template>

<script>
import HelloWorld from '../components/HelloWorld';
import LoggedIn from '@/components/LoggedIn';
import {mapState} from 'vuex';
export default {
  props: ['auth', 'authenticated', 'qualified_profile'],
  components: {
    HelloWorld,
    LoggedIn,
  },
  computed: {
    ...mapState(['myprofile']),
  },
};
</script>
